import PropTypes from 'prop-types';
import React from 'react';

const DocumentSvg = ({ color, width, height }) => {
  return (
    <svg width={`${width || 20}`} height={`${height || 20}`} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.3337 8.33333V12.5C18.3337 16.6667 16.667 18.3333 12.5003 18.3333H7.50033C3.33366 18.3333 1.66699 16.6667 1.66699 12.5V7.5C1.66699 3.33333 3.33366 1.66666 7.50033 1.66666H11.667"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M18.3337 8.33333H15.0003C12.5003 8.33333 11.667 7.5 11.667 5V1.66666L18.3337 8.33333Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

DocumentSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default DocumentSvg;
